import TechAddToPortfolio from './TechAddToPortfolio';

export default TechAddToPortfolio;
